import { DurationTimeConfig } from './DurationForm.types';

export enum Duration {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
}

export const DAY_CONFIG: DurationTimeConfig = {
  min: 0,
  max: 365,
};

export const HOUR_CONFIG: DurationTimeConfig = {
  min: 0,
  max: 23,
};

export const MINUTE_CONFIG: DurationTimeConfig = {
  min: 0,
  max: 59,
};

export const defaultErrorState = {
  [Duration.Day]: false,
  [Duration.Hour]: false,
  [Duration.Minute]: false,
};
